/** Hook to load the catalogue of all measures. */

import { useEffect, useState } from "react";

import { apiClient } from "../api/client";
import { ApiError, type CatalogueEntry } from "../types";

interface UseCatalogueResult {
  catalogue: CatalogueEntry[];
  loading: boolean;
  error: string | null;
}

export function useCatalogue(enabled = true): UseCatalogueResult {
  const [catalogue, setCatalogue] = useState<CatalogueEntry[]>([]);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    apiClient
      .getCatalogue()
      .then((data) => {
        if (!cancelled) {
          setCatalogue(data);
          setError(null);
        }
      })
      .catch((err: ApiError | Error) => {
        if (!cancelled) {
          setError(err.message);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { catalogue, loading, error };
}
